import { trigger, transition, style, animate, state } from "@angular/animations";
import { Component, OnInit, Input, OnDestroy, HostListener, HostBinding } from "@angular/core";
import { IdService } from "../../shared/services/id.service";

@Component({
	selector: "rbc-tab-content",
	templateUrl: "./tab-content.component.html",
	animations: [
		trigger("opacity", [
			state("true", style({
				opacity: 1
			})),
			state("false", style({
				opacity: 0
			})),
			transition("true => false", animate("550ms ease-in")),
			transition("false => true", animate("550ms ease-out"))
		]),
		// trigger("opacity", [
		// 	transition(":enter", [
		// 		style({ opacity: 0,  transform:"translateX(-100%)"}),
		// 		animate("550ms 550ms ease-in", style({opacity: 1,  transform:"translateX(0%)", background: "red"}))
		// 	]),

		// 	transition(":leave", [
		// 		style({  transform:"translateX(0%)"}),
		// 		animate("550ms ease-out", style({overflow:"hidden",transform:"translateX(-100%)",  background: "green"}))
		// 	]),
		// 	state("true", style({
		// 		// position: "absolute"

		// 	})),
		// 	state("false", style({
		// 		position: "absolute",
		// 		visibility: "hidden",
		// 		top: 0,
		// 		left: 0,
		// 		width: "100%",
		// 		opacity:0
		// 	})),
		// 	// state("void", style({
		// 	// 	opacity: 0,
		// 	// 	visibility: "hidden"

		// 	// })),
		// ]),

	]
})
export class TabContentComponent implements OnInit, OnDestroy {
	// Input Parameters
	@Input() id: string;
	@Input() name: number | string;
	@Input() disabled = false;
	@Input() hasTransition = true;
	@Input() routerTo;
	@Input() router = false;

	index = 0;
	isActive = false;

	constructor(private idService: IdService) { }

	@HostBinding('@opacity') get slideIn() {
		return this.isActive;
	}

	ngOnInit(): void {
		this.id = this.id ? this.id : this.idService.generate();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}
}
